import { useQuery } from "@tanstack/react-query";
import { Alert, Card, CardContent, Stack, Typography } from "@mui/material";
import { apiClient } from "../providers/apiClient";
type Counts = Array<{ status: string; _count: number }>;
export function ChatOperations() {
  const query = useQuery({
    queryKey: ["chat-operations"],
    queryFn: () =>
      apiClient.get<{ runs: Counts; deliveries: Counts; memories: number }>(
        "/admin/chat/operations",
      ),
    refetchInterval: 15000,
  });
  if (query.isError)
    return <Alert severity="error">Could not load chat operations.</Alert>;
  return (
    <Stack spacing={2} sx={{ p: 0 }}>

      <Typography>
        Durable jobs recover automatically after a restart. Counts contain no
        conversation content.
      </Typography>
      {(["runs", "deliveries"] as const).map((key) => (
        <Card key={key}>
          <CardContent>
            <Typography variant="h6">
              {key === "runs" ? "Elisa responses" : "Message notifications"}
            </Typography>
            {query.data?.[key].map((row) => (
              <Typography key={row.status}>
                {row.status}: {row._count}
              </Typography>
            ))}
          </CardContent>
        </Card>
      ))}
      <Typography>
        Stored conversation memories: {query.data?.memories ?? "…"}
      </Typography>
    </Stack>
  );
}
